export const apiUrl = process.env.VUE_APP_API_URL;

export const netentConfig = {
  staticServer: process.env.VUE_APP_NETENT_STATIC_SERVER,
  gameServer: process.env.VUE_APP_NETENT_GAME_SERVER,
  casinoId: process.env.VUE_APP_NETENT_CASINOID
};

export const config = {
  headers: { Authorization: process.env.VUE_APP_AUTHKEY }
}

export const wsFeatures = process.env.VUE_APP_WS_FEATURES;

export const wsCooldownMaxTime = process.env.VUE_APP_WS_COOLDOWN_MAX_TIME;
